module.exports = __webpack_public_path__ + "img/logo.fdea5747.svg";